import React from 'react';

const L = (lang, el, en) => (lang === 'el' ? el : en);
const eur = (v) => `€${Number(v || 0).toFixed(2)}`;
const dmy = (d) => (d && d.length >= 10 ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : d || '—');
const ST = {
  paid: ['Εισπράχθηκε', 'Received', 'bg-emerald-600'],
  partially_paid: ['Μερικώς', 'Partial', 'bg-amber-500'],
  unpaid: ['Ανεξόφλητο', 'Outstanding', 'bg-red-600'],
};

export const ReserveChargesSection = ({ charges, lang }) => {
  if (!charges || !charges.rows?.length) return null;
  const Tile = ({ label, value, cls, testid }) => (
    <div className="px-4 py-3 border-r border-zinc-200 last:border-r-0"><div className="text-[10px] uppercase tracking-wider text-zinc-500">{label}</div><div className={`text-lg font-mono font-bold ${cls || ''}`} data-testid={testid}>{eur(value)}</div></div>
  );
  return (
    <div className="bg-white border border-zinc-200" data-testid="rf-charges-section">
      <div className="px-5 py-3 border-b border-zinc-200">
        <h3 className="font-semibold text-sm">{L(lang, 'Χρεώσεις Αποθεματικού (Έκτακτο Αποθεματικό & Αποθεματικό)', 'Reserve Fund Charges (Extra Reserve & Reserve Fund)')}</h3>
        <p className="text-[11px] text-zinc-500 mt-0.5">{L(lang, 'Στο υπόλοιπο του Αποθεματικού προστίθενται μόνο τα ποσά που εισπράχθηκαν. Τα ανεξόφλητα εμφανίζονται ως οφειλόμενα και δεν μετρούν ως χρήματα του ταμείου.', 'Only received amounts increase the Reserve Fund balance. Unpaid charges are shown as outstanding and are not money in the fund.')}</p>
      </div>
      <div className="grid grid-cols-3 border-b border-zinc-200">
        <Tile label={L(lang, 'Σύνολο χρεώσεων', 'Total charged')} value={charges.total_charged} testid="rf-charges-total-charged" />
        <Tile label={L(lang, 'Εισπράχθηκαν (στο Αποθεματικό)', 'Received (in fund)')} value={charges.total_received} cls="text-emerald-700" testid="rf-charges-total-received" />
        <Tile label={L(lang, 'Οφειλόμενα (ανεξόφλητα)', 'Outstanding (unpaid)')} value={charges.total_outstanding} cls="text-red-700" testid="rf-charges-total-outstanding" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs" data-testid="rf-charges-table">
          <thead><tr className="bg-zinc-50 text-zinc-600">
            {[L(lang, 'Ημερομηνία', 'Date'), L(lang, 'Διαμέρισμα', 'Apartment'), L(lang, 'Τιμολόγιο', 'Invoice'), L(lang, 'Περιγραφή', 'Description')].map((h) => <th key={h} className="px-3 py-2 text-left font-semibold">{h}</th>)}
            {[L(lang, 'Χρέωση', 'Charged'), L(lang, 'Εισπράχθηκε', 'Received'), L(lang, 'Οφειλόμενο', 'Outstanding')].map((h) => <th key={h} className="px-3 py-2 text-right font-semibold">{h}</th>)}
            <th className="px-3 py-2 text-left font-semibold">{L(lang, 'Κατάσταση', 'Status')}</th>
          </tr></thead>
          <tbody>
            {charges.rows.map((r) => {
              const st = ST[r.status] || ST.unpaid;
              return (
                <tr key={r.invoice_id} className="border-t border-zinc-100" data-testid={`rf-charge-row-${r.invoice_id}`}>
                  <td className="px-3 py-1.5 whitespace-nowrap">{dmy(r.date)}</td>
                  <td className="px-3 py-1.5">{r.apartment_number || '—'}</td>
                  <td className="px-3 py-1.5 font-mono">{r.invoice_number}</td>
                  <td className="px-3 py-1.5">{r.description}{!r.reserve_only && <span className="text-zinc-400"> · {L(lang, 'μέρος τιμολογίου κοινοχρήστων', 'part of common expenses invoice')}</span>}</td>
                  <td className="px-3 py-1.5 text-right font-mono">{eur(r.charged)}</td>
                  <td className="px-3 py-1.5 text-right font-mono text-emerald-700">{eur(r.received)}</td>
                  <td className={`px-3 py-1.5 text-right font-mono ${r.outstanding > 0 ? 'text-red-700 font-semibold' : 'text-zinc-400'}`}>{eur(r.outstanding)}</td>
                  <td className="px-3 py-1.5"><span className={`text-[10px] text-white px-1.5 py-0.5 ${st[2]}`} data-testid={`rf-charge-status-${r.invoice_id}`}>{L(lang, st[0], st[1])}</span></td>
                </tr>);
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReserveChargesSection;
